var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('com-header',{on:{"mask":_vm.maskitem}}),_c('router-view',{staticClass:"minhet"}),_c('com-footer'),_c('div',{class:{ bif: _vm.bi },style:(_vm.contentStyleObj)})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }